import { FlattenSeat } from '../types';

export class TextFormattingUtils {

  public static formatText(rule: string, seat: FlattenSeat): string {
    if (rule && seat) {
      /**
       * rules:
       * @a - align curve title
       * @p - seat number
       * @r - rankToken
       * @z - seat count
       * @t - title
       */
      if (rule.includes('@a')) {
        rule = rule.replace('@a', seat.rank ? seat.rank?.toString() : '');
      }

      if (rule.includes('@p')) {
        rule = rule.replace('@p', seat.seatNumber ? seat.seatNumber?.toString() : '');
      }

      if (rule.includes('@r')) {
        rule = rule.replace('@r', seat.rankToken ? seat.rankToken?.toString() : '');
      }

      if (rule.includes('@z')) {
        rule = rule.replace('@z', seat.seatCount ? seat.seatCount?.toString() : '');
      }

      if (rule.includes('@t')) {
        rule = rule.replace('@t', TextFormattingUtils.formatText(seat.ruleTitle, seat));
      }
    }

    return rule;
  }
}
